import request from '../../../config/Request'

const roleApi = {
    menuQuery: '/api/Menu/queryList',//查询菜单列表
    menuDetail: '/api/menu/queryDetail',//查询菜单详情
    menuEdit: '/api/menu/editDetail',//编辑菜单列表
    menuDel: '/api/menu/delDetail',//删除菜单列表

    userQueryList:'/api/User/queryList',// 查询用户信息列表
    userQueryDetail:'/api/User/queryDetail',// 查询用户信息详细
    userEditDetail:'/api/User/editDetail',// 编辑用户信息
    userDelDetail:'/api/User/delDetail',// 删除用户信息
    userQueryRoleByUserId:'/api/User/queryRoleByUserId',// 根据用户ID查询所具有的角色列表
    userEditRoleByUserId:'/api/User/editRoleByUserId',// 根据用户id分配角色列表

    roleQueryList:'/api/Role/queryList',// 查询角色信息列表
    roleQueryDetai:'/api/Role/queryDetai',// 查询角色信息详细
    roleEditDetail:'/api/Role/editDetail',// 编辑角色信息
    roleDelDetail:'/api/Role/delDetail',// 删除角色信息
    roleQueryPowerByRoleId:'/api/Role/queryPowerByRoleId',// 根据角色ID查询所具有的用户列表
    roleEditPowerByRoleId:'/api/Role/editPowerByRoleId',// 根据角色id分配权限列表

    powerQueryList: '/api/Power/queryList',// 查询权限信息列表
    powerQueryDetail:'api/Power/queryDetail', //查询权限信息详细
    powerEditDetail:'api/Power/editDetail', //编辑权限信息
    powerDelDetail:'api/Power/delDetail', //删除权限信息
    powerQueryMenu:'api/Power/queryMenuByPowerId', //根据权限ID查询所具有的菜单列表
    powerEditMenu:'api/Power/editMenuByPowerId', //根据权限id分配菜单列表

    groupQueryList: '/api/Group/queryList', //查询部门信息列表
    groupQueryDetail: '/api/Group/queryDetail', //查询部门信息详细
    groupEditDetail: '/api/Group/editDetail', //编辑部门信息
    groupDelDetail: '/api/Group/delDetail', //删除部门信息
};

/**
 * 查询菜单列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getMenuList(parameter) {
    return request({
        url: roleApi.menuQuery,
        data: parameter
    })
}
/**
 * 编辑菜单
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function editMenu(parameter) {
    sessionStorage.setItem('menu', '');
    return request({
        url: roleApi.menuEdit,
        data: parameter
    })
}
/**
 * 删除菜单
 * @param parameter 删除参数（菜单ID）
 * @returns {AxiosPromise} 请求对象
 */
export function DeleteMenu(parameter) {
    return request({
        url: roleApi.menuDel,
        data: parameter
    })
}
/**
 * 查询部门信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getGroupQueryList(parameter) {
    return request({
        url: roleApi.groupQueryList,
        data: parameter
    })
}
/**
 * 编辑部门信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function groupEditDetail(parameter) {
    return request({
        url: roleApi.groupEditDetail,
        data: parameter
    })
}
/**
 * 删除部门信息
 * @param parameter 删除参数（菜单ID）
 * @returns {AxiosPromise} 请求对象
 */
export function groupDelDetail(parameter) {
    return request({
        url: roleApi.groupDelDetail,
        data: parameter
    })
}
/**
 * 查询用户信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getUserQueryList(parameter) {
    return request({
        url: roleApi.userQueryList,
        data: parameter
    })
}
/**
 * 编辑用户信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function userEditDetail(parameter) {
    return request({
        url: roleApi.userEditDetail,
        data: parameter
    })
}
/**
 * 删除用户信息
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function userDelDetail(parameter) {
    return request({
        url: roleApi.userDelDetail,
        data: parameter
    })
}
/**
 * 根据用户ID查询所具有的角色列表
 * @param parameter 参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function userQueryRoleByUserId(parameter) {
    return request({
        url: roleApi.userQueryRoleByUserId,
        data: parameter
    })
}
/**
 * 根据用户id分配角色列表
 * @param parameter 参数
 * @returns {AxiosPromise} 请求对象
 */
export function userEditRoleByUserId(parameter) {
    return request({
        url: roleApi.userEditRoleByUserId,
        data: parameter
    })
}
/**
 * 查询权限信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getPowerQueryList(parameter) {
    return request({
        url: roleApi.powerQueryList,
        data: parameter
    })
}
/**
 * 编辑权限信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function powerEditDetail(parameter) {
    return request({
        url: roleApi.powerEditDetail,
        data: parameter
    })
}
/**
 * 删除权限信息
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function powerDelDetail(parameter) {
    return request({
        url: roleApi.powerDelDetail,
        data: parameter
    })
}
/**
 * 根据权限ID查询所具有的菜单列表
 * @param parameter 参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function powerQueryMenu(parameter) {
    return request({
        url: roleApi.powerQueryMenu,
        data: parameter
    })
}
/**
 * 根据权限id分配菜单列表
 * @param parameter 参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function powerEditMenu(parameter) {
    return request({
        url: roleApi.powerEditMenu,
        data: parameter
    })
}
/**
 * 查询角色信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getRoleQueryList(parameter) {
    return request({
        url: roleApi.roleQueryList,
        data: parameter
    })
}
/**
 * 编辑角色信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function roleEditDetail(parameter) {
    return request({
        url: roleApi.roleEditDetail,
        data: parameter
    })
}
/**
 * 删除角色信息
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function roleDelDetail(parameter) {
    return request({
        url: roleApi.roleDelDetail,
        data: parameter
    })
}
/**
 * 根据用户ID查询所具有的角色列表
 * @param parameter 参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function roleQueryPowerByRoleId(parameter) {
    return request({
        url: roleApi.roleQueryPowerByRoleId,
        data: parameter
    })
}
/**
 * 根据角色id分配权限列表
 * @param parameter 参数
 * @returns {AxiosPromise} 请求对象
 */
export function roleEditPowerByRoleId(parameter) {
    return request({
        url: roleApi.roleEditPowerByRoleId,
        data: parameter
    })
}
